import graphql from "babel-plugin-relay/macro";

export const EditPolicyQuery = graphql`
  query EditPolicyQuery($documentPk: Int!, $continueDraft: Boolean) {
    documentEdit(pk: $documentPk, continueDraft: $continueDraft) {
      document {
        ...commentForm_document
        id
        pk
        name
        status
        actions(isEditPage: true) {
          id
          pk
          actionType
          actionDate
          comment
          canEdit
          isExternal
          user {
            id
            userDisplay(userDisplayType: FORWARD)
          }
        }
      }
      documentSave {
        pk
        savedCopy {
          pk
          author {
            pk
            firstName
            lastName
            email
          }
        }
      }
      editForm {
        name
        author {
          pk
          firstName
          lastName
          title
        }
        category {
          pk
          name
        }
        categoryChoices {
          pk
          name
        }
        flowTemplate {
          pk
          name
        }
        flowTemplateChoices {
          pk
          name
        }
        bloc {
          pk
          name
        }
        blocChoices {
          pk
          name
        }
        html
        activeLifespan
        expirationDate
        isAForm
        restricted
        regulations
        onesourceDocuments {
          oneSourceDocumentId
          catalogNumber
          manufacturerName
          revisionInformation
          viewUrl
        }
      }
      tagForm {
        tags {
          pk
          name
        }
      }
      saveForm {
        hasSavedCopy
        continueDraft
        timestamp
      }
      scheduledEffectiveDateForm {
        effectiveDate
        effectiveDateTimedelta
        effectiveDateAlgorithm
      }
      alreadyChanged
      error {
        statusCode
        message
      }
      tenantsToRedirect {
        name
        url
      }
      rtlSupport
      newCkeditor
      redirectUrl
      policyActions
    }
  }
`;

export default EditPolicyQuery;
